export const API_CONFIG = {
  BASE_URL: process.env.NEXT_PUBLIC_API_URL_WITHOUT_DASHBOARD || "",
  DEFAULT_HEADERS: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
};
